'use strict';

export default function SearchRoutePoint({ 
    label,
    point, 
    direction,
    error,
    index,
    airports,
    onlyAirports,
    maxAirports,
    onSelect,
    onFocus,
    dropDownParent = '.page',
}) {
    const [ value, setValue ] = React.useState( point?.title || '' )
    const [ icao, setIcao ] = React.useState( point?.icao || '' )
    const [ flagImg, setFlagImg ] = React.useState( point?.flag_img || '' )
    const inputRef = React.useRef()

    const filteredAirports = onlyAirports
        ? airports.filter(e => e.type !== 'city')
        : airports
    
    React.useEffect(() => {
        $.widget( "app.autocomplete", $.ui.autocomplete, {
            _renderItem: function( ul, item ) {
                item.label = item.title;
                let result = $("<li>")
                    .append(`
                        <div class="autocomplete-item">
                            <img src="${item.flag_img}" class="flag-icon">
                            <div>${item.title}</div>
                            <span class="code">${item.icao || ''}</span>
                        </div>
                    `)
                result.appendTo(ul)
                return result;
            }
        });
    }, [])
    
    React.useEffect(() => {
        const $input = $(inputRef.current);
        
        const parent = $input.closest(dropDownParent) || undefined;
        
        function handleInputFocus () {
            if (!$(this).val().trim()) {
                $(this).keydown();
            } else {
                $(this).next('.direction-code').hide();
                $(this).select();
            }
        }
        
        function handleInputBlur () {
            $(this).next('.direction-code').show();
        }
        function handleWindowScroll () {
            if (!window.isAnimatedScrolling) {
                $input.blur();
                $input.autocomplete('close');
            }
        }
        
        $input.autocomplete({
            minLength: 0,
            delay: 300,
            appendTo: parent,
            source: filteredAirports,
            select: function (event, ui) {
                event.preventDefault();
                onSelect(ui.item);
                setValue(ui.item.title);
                setIcao(ui.item.icao);
                setFlagImg(ui.item.flag_img);
            },
            open: function () {
                const acData = $(this).autocomplete("widget");
                acData.css("top", parseInt(acData.css("top")) + 5 + "px");

                const $input = $(this);
                const $menu = $input.autocomplete("widget");

                $menu.position({
                    my: "left top",
                    at: "left bottom+5",
                    of: $input
                });

                $(window).on("scroll.autopos", function () {
                    $menu.position({
                        my: "left top",
                        at: "left bottom+5",
                        of: $input
                    });
                });
            },
        })
            .bind('focus', handleInputFocus)
            .bind('blur', handleInputBlur)

        $(window).on('scroll', handleWindowScroll);
        
        return () => {
            $(window).off('scroll', handleWindowScroll);
            $input.off('blur', handleInputBlur);
            $input.off('focus', handleInputFocus);
            $input.autocomplete('destroy');
        }
    }, [])
    
    React.useEffect(() => {
        if (inputRef.current) {
            const $input = $(inputRef.current);
            $input.autocomplete('option', 'source', filteredAirports)
            $input.autocomplete('option', 'delay', 10)
        }
    }, [ airports ])
    
    React.useEffect(() => {
        setValue(point?.title || '')
        setIcao(point?.icao || '')
        setFlagImg(point?.flag_img || '')
    }, [ point?.title, point?.icao, point?.flag_img ])


    const handleChange = (value) => {
        const $input = $(inputRef.current);
        
        const query_params = [
            {key: "onlyAirports", value: onlyAirports ? 1 : 0},
            {key: "max", value: maxAirports}
        ]
            .filter(e => !!e.value)
            .map(({key, value}) => `${key}=${value}`)
            .join('&')

        let source = (request, response) => $.ajax ( {
            url: apiAction.apiUrl ( `autocomplete/airportOrCity${ !!query_params ? `?${ query_params }` : "" }` ),
            dataType: "json",
            data: apiAction.prepareData ( request ),
            success: response,
        } )

        let delay = 300;
        if (!value.trim()) {
            source = filteredAirports;
            delay = 10;
        }
        
        $input.autocomplete('option', 'source', source);
        $input.autocomplete('option', 'delay', delay);
        
        onSelect({ title: value.replace(/^\s+/, '') || '' });
        setValue(value.replace(/^\s+/, '') || '');
        setIcao('');
        setFlagImg('');
    }

    return <div className={cn(`search-inputbox direction-${direction}`, error && 'error', flagImg && 'changed')}>
        {flagImg && <img src={flagImg} className="direction-flag"/>}
        <input ref={inputRef} type="text" placeholder={label} className={`routePoint${direction}${index}`} value={value} onChange={(e) => handleChange(e.currentTarget.value)} onFocus={() => onFocus && onFocus()}/>
        <span className="direction-code">{icao}</span>
        {!!value && <a role='button' className="search-inputbox__clear" style={{display:'block'}} onClick={(e) => handleChange('')}></a>}
    </div>
}
